import clsx from "clsx";
import React, { ButtonHTMLAttributes } from "react";

import { ReactComponent as DownloadIcon } from "../../assets/svg/download.svg";

import styles from "./DownloadButton.module.scss";

export type Props = {
  calling?: boolean;
  className?: string;
} & ButtonHTMLAttributes<HTMLButtonElement>;

const DownloadButton: React.FC<Props> = ({
  calling = false,
  className = "",
  children,
  ...rest
}) => {
  return (
    <button
      disabled={calling}
      className={clsx(styles.btnDownload, className)}
      {...rest}
    >
      <div>
        <DownloadIcon />
      </div>
      <span>{children}</span>
    </button>
  );
};

export default DownloadButton;
